import React from 'react';
import { Link } from 'react-router-dom';
import useNow from '../../hooks/useNow';
import { turnAt, msUntilTurn, formatDuration, BLOCKS_PER_TURN } from '../../utils/schedule';

/**
 * Versión mini del schedule para la portada: quién produce ahora (con su
 * progreso) y los 3 siguientes. Enlaza a /producers.
 */
const ScheduleTicker = ({ active, lagMs = 0 }) => {
  const now = useNow(500) - lagMs;
  const n = active.length;
  if (!n) return null;
  const { index: cur, block } = turnAt(n, now);
  const nextOnes = [1, 2, 3].map((k) => (cur + k) % n).filter((i) => i !== cur);

  return (
    <div className="px-5 py-3 border-b border-gray-200 bg-gray-50 flex flex-wrap items-center gap-x-5 gap-y-2 text-xs">
      <span className="flex items-center gap-2 min-w-0">
        <span aria-hidden="true" className="w-2 h-2 rounded-full bg-green-600 ring-4 ring-green-100 shrink-0" />
        <span className="text-gray-500">Now</span>
        <Link to={`/account-detail/${active[cur]}`} className="link font-semibold text-sm">{active[cur]}</Link>
        <span className="w-16 h-[3px] rounded bg-indigo-100" aria-label={`block ${block} of ${BLOCKS_PER_TURN}`}>
          <span className="block h-[3px] rounded bg-indigo-700" style={{ width: `${(block / BLOCKS_PER_TURN) * 100}%` }} />
        </span>
      </span>
      <span className="flex flex-wrap items-center gap-x-3 gap-y-1 text-gray-500">
        Next
        {nextOnes.map((i) => (
          <span key={active[i]}>
            <Link to={`/account-detail/${active[i]}`} className="link">{active[i]}</Link>
            <span className="text-gray-400"> {formatDuration(msUntilTurn(i, n, now))}</span>
          </span>
        ))}
      </span>
      <Link to="/producers" className="link ml-auto font-medium">Live schedule →</Link>
    </div>
  );
};

export default React.memo(ScheduleTicker);
